import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { ConfigService } from 'services/config/config.service';

@Injectable({
    providedIn: 'root'
})

export class NotificationService {
    constructor(private configSvc: ConfigService, private http: HttpClient) { }

    // #region Get Notifications Service Call

	GetNotifications(AuthToken: string, CurrentRole: string, AwardID: number, SchoolNumber: string, SchoolYear: string) {
        return this.http.get<NotificationsInfo>(this.configSvc.hostAddress + `Api/Services/Notification/GetNotifications?` +
            `AuthToken=${AuthToken || ''}&CurrentRole=${CurrentRole || ''}&AwardID=${AwardID || ''}&SchoolNumber=${SchoolNumber || ''}&SchoolYear=${SchoolYear}`)
            .pipe(
                map(notices => {
                    if (notices) {
                        notices.LastLogin = (notices.LastLogin ? new Date(notices.LastLogin) : null);
                    }

                    return notices;
                })
            );
    }

    // #endregion
}

// #region Custom Classes

// #region Notification Item

export class NotificationItem {
    Details?: any[];
    IconName?: string;
    LinkState?: string;
    Message?: string;
    SortOrder?: number;
}

// #endregion

// #region Notifications Info

export class NotificationsInfo {
    LastLogin?: Date;
    Notices?: NotificationItem[];
}

// #endregion

// #endregion
